// extracted by mini-css-extract-plugin
module.exports = {"contact":"Contact_contact__Lv31H","error":"Contact_error__2LNjf"};